import type { BackendSessionActions } from './backendSession';
import type { BackendSessionJsonRpcActions } from './backendSessionJsonRpc';
import type { BootActions } from './boot';
import type { CodeExplanationActions } from './codeExplanation';
import type { ContentAuthorizationStatusActions } from './contentAuthorization';
import { CourseAction } from './course';
import type { DatawarehouseSessionActions } from './datawarehouseSession';
import type { ExerciseActions } from './exercises';
import type { ExternalExerciseActions } from './externalExercise';
import type { LocationActions } from './location';
import type { SetWorkspaceNotesAction } from './notes';
import type { OnboardingMilestonesActions } from './onboardingMilestones';
import type { OutputActions } from './output';
import type { SettingActions } from './settings';
import { UserAction } from './user';

export * from './backendSession';
export * from './backendSessionJsonRpc';
export * from './datawarehouseSession';
export * from './boot';
export * from './chapter';
export * from './course';
export * from './exercises';
export * from './location';
export * from './output';
export * from './settings';
export * from './systemStatus';
export * from './user';
export * from './externalExercise';
export * from './window';
export * from './mobilePopup';
export * from './onboardingMilestones';
export * from './contentAuthorization';
export * from './dashboard';
export * from './notes';
export * from './codeSubmission';
export * from './codeExplanation';

export const noopAction = { type: 'noop' } as const;
type NoopAction = typeof noopAction;

export const emptyAction = {} as Action;

export type Action =
  | BootActions
  | BackendSessionActions
  | BackendSessionJsonRpcActions
  | DatawarehouseSessionActions
  | ContentAuthorizationStatusActions
  | ExerciseActions
  | NoopAction
  | OutputActions
  | LocationActions
  | SettingActions
  | OnboardingMilestonesActions
  | ExternalExerciseActions
  | SetWorkspaceNotesAction
  | CodeExplanationActions
  | UserAction
  | CourseAction;
